<template>
    <div class="preferences-container">
        <span
            v-for="preference in preferences"
            :key="preference.preferenceId"
            :data-value="preference.preferenceId"
            class="preferences-option"
            :class="{ 'selected': preference.selected, 'disabled': disabled }"
            @click="toggle"
        >
            {{ config[preference.name] }}
        </span>
    </div>
</template>
<script>
import { SolutionConsumer, UserConsumer } from '../../mixins';

export default {
    name: 'Preferences',
    mixins: [SolutionConsumer, UserConsumer],
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            allPreferences: [],
        };
    },
    computed: {
        preferences () {
            return this.allPreferences.map((preference) => ({ ...preference, selected: this.value.includes(preference.preferenceId) }));
        },
    },
    async created () {
        this.allPreferences = await this.getAllReferences();
    },
    methods: {
        toggle (e) {
            if (this.disabled) { return; }
            const { value } = e.target.dataset;
            this.$emit('input', this.value.includes(value) ? this.value.filter((preferenceId) => preferenceId !== value) : [...this.value, value]);
        },
    },
};
</script>
<style lang="scss" scoped>
  .preferences-container {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;

      > .preferences-option {
          border-radius: 1rem;
          background-color: rgb(231, 231, 231);
          color: rgb(136, 133, 133);
          padding: 0.5rem 1rem;

          &:hover {
              cursor: pointer;
          }

          &.disabled {
            color: rgb(200, 200, 200);
            cursor: not-allowed;
          }

          &.selected {
              background-color: rgb(30, 165, 124);
              color: white;

              &.disabled {
                background-color: rgb(231, 231, 231);
                cursor: not-allowed;
              }

              &::before {
                background-image: url('../../assets/img/check-white.svg');
                background-repeat: no-repeat;
                content: '';
                display: inline-block;
                height: 0.7rem;
                width: 0.8rem;
              }
          }
      }
  }
</style>
